module.exports = __webpack_public_path__ + "img/kalisbros.7598aa73.png";